import styled, { css, keyframes } from 'styled-components';
import isChromatic from 'chromatic/isChromatic';

import Grid from '@klv/utils/grid';
import Buttons from '@klv/molecules/buttons';
import Typography from '@klv/atoms/typography';
import * as styles from '@klv/organisms/logos/styles/logos.module.scss';
import { GradientText } from '../../../atoms/gradient-text';
import customImage from '../assets/custom.webp';
import { HomepageLogos } from '../../../../styles';

export const StyledHeroWrapper = styled.div`
  margin-top: calc(var(--layout-universal-navbar-height) * -1);
  padding-top: var(--layout-universal-navbar-height);
  position: relative;
`;

export const StyledHero = styled(Grid)`
  &:first-of-type {
    padding-top: 8.8rem;
    padding-bottom: 0;
    margin-bottom: 0;
  }
  &:last-of-type {
    margin-top: 0;
    padding-top: 0;
  }

  ${HomepageLogos} {
    grid-column: 1 / -1;

    .${styles.styledImage} {
      opacity: 1 !important;
    }
  }
`;

export const HeroIconWrapper = styled.div`
  text-align: center;
  grid-column: 1 / -1;
  z-index: 1;
  
  svg {
    display: inline-block;
    margin-bottom: 3.2rem;
  }
`;

const fadeInUpKeyFrames = keyframes`
  0% { 
    transform: translateY(2rem);
    opacity: 0;
  }
  100% {
    transform: translateY(0rem);
    opacity: 1;
  }
`;

export const fadeInUp = css`
  ${!isChromatic() && css`
    transform: translateY(2rem);
    opacity: 0;
    animation-name: ${fadeInUpKeyFrames};
    animation-duration: 1.5s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  `}
`;

export const HeroHeadline = styled(Typography)`
  ${({ theme }) => css`
    grid-column: 1 / -1;
    text-align: center;
    ${theme.fonts.sohne.light}
    color: ${theme.colors.white};
    margin-bottom: 2rem;
    ${fadeInUp}
    animation-delay: .5s;
    ${theme.screenSize.s576.mediaQuery} {
      grid-column: 2 / 12;
    }
    ${theme.screenSize.s768.mediaQuery} {
      grid-column: 3 / 11;
    }
    ${theme.screenSize.s1200.mediaQuery} {
      grid-column: 2 / 12;
      margin-bottom: 2.4rem ;
    }
    strong {
      ${GradientText}
      font-weight: 300;
    }
  `}
`;

export const HeroSubheader = styled(Typography)`
  ${({ theme }) => css`
    color: ${theme.colors.white};
    grid-column: 1 / -1;
    text-align: center;
    margin-bottom: 3.6rem;
    font-size: 2rem;
    ${fadeInUp}
    animation-delay: .75s;
    ${theme.screenSize.s576.mediaQuery} {
      grid-column: 3 /span 8;
      font-size: 2.4rem;
    }
    ${theme.screenSize.s1200.mediaQuery} {
      font-size: 2.4rem;
    }
    ${theme.screenSize.s1366.mediaQuery} {
      margin-bottom: 4.8rem;
    }
  `}
`;

export const CustomImageContainer = styled.div`
  width: 100%;
  ${fadeInUp}
  background-image: url(${customImage});
  background-size: 52.6rem 17rem;
  height: 17rem;
  animation-delay: .75s;
  background-position: center;
  background-repeat: no-repeat;
  ${({ theme }) => css`
    ${theme.screenSize.s576.mediaQuery} {
      background-size: 77.2rem 25rem;
      height: 25rem;
    }
    ${theme.screenSize.s768.mediaQuery} {
      background-size: 101.8rem 33rem;
      height: 33rem;
    }
    ${theme.screenSize.s1200.mediaQuery} {
      background-size: 154.3rem 49.6rem;
      height: 49.6rem;
    }
    ${theme.screenSize.s1366.mediaQuery} {
      background-size: 170rem 55rem;
      height: 55rem;
    }
  `}
`;

export const StyledButtons = styled(Buttons)`
  ${({ theme }) => css`
    grid-column: 1 / -1;
    justify-content: center;
    margin-bottom: 3.6rem;
    ${fadeInUp}
    animation-delay: .75s;
    ${theme.screenSize.s768.mediaQuery} {
      grid-column: 3 / 11;
      margin-bottom: 5.2rem;
    }
    ${theme.screenSize.s1200.mediaQuery} {
      font-size: 6.4rem;
    }
  `}
`;

export const FadeInForm = styled.div`
    grid-column: 1 / -1;
    justify-content: center;
    display: inline-flex;
    align-items: center;
    position: relative;
    ${fadeInUp}
    animation-delay: .75s;
`;
